export default __webpack_public_path__ + "static/media/codewar.9248b102.jpg";